import type { ReactNode } from 'react';
import type { KpiDateRangePreset, KpiResponse } from '~/apis/analyticsApi';
import { ALL_REGION } from '~/pages/users/form/types';

export type DashboardFilterState = {
  dateRangePreset: KpiDateRangePreset;
  regionalCode: string;
};

export const DEFAULT_DASHBOARD_FILTERS: DashboardFilterState = {
  dateRangePreset: 'this_month',
  regionalCode: ALL_REGION,
};

export const DATE_RANGE_PRESET_OPTIONS: { value: KpiDateRangePreset; label: string }[] = [
  { value: 'this_month', label: 'This Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'this_year', label: 'This Year' },
  { value: 'last_year', label: 'Last Year' },
];

export type KpiAccent =
  | 'green'
  | 'orange'
  | 'red'
  | 'gold'
  | 'teal'
  | 'purple'
  | 'blue'
  | 'darkBlue';

export type KpiCardConfig = {
  key: keyof KpiResponse;
  label: string;
  subtext: string;
  accent: KpiAccent;
  icon: ReactNode;
  /** When set, shows primary vs secondary values plus a percentage. */
  comparison?: {
    secondaryKey: keyof KpiResponse;
    percentageKey: keyof KpiResponse;
  };
};

export const KPI_ACCENT_COLORS: Record<KpiAccent, { main: string; bg: string }> = {
  green: { main: '#2e7d32', bg: 'rgba(46, 125, 50, 0.12)' },
  orange: { main: '#ed6c02', bg: 'rgba(237, 108, 2, 0.12)' },
  red: { main: '#d32f2f', bg: 'rgba(211, 47, 47, 0.12)' },
  gold: { main: '#f9a825', bg: 'rgba(249, 168, 37, 0.15)' },
  teal: { main: '#00897b', bg: 'rgba(0, 137, 123, 0.12)' },
  purple: { main: '#7b1fa2', bg: 'rgba(123, 31, 162, 0.12)' },
  blue: { main: '#1976d2', bg: 'rgba(25, 118, 210, 0.12)' },
  darkBlue: { main: '#0d47a1', bg: 'rgba(13, 71, 161, 0.12)' },
};

export function getKpiAccentColors(accent: KpiAccent) {
  return KPI_ACCENT_COLORS[accent];
}
